module.exports = __webpack_public_path__ + "img/multiplier15_freespins.ae0ca5d6.png";